import React from 'react';
import { processData } from '../data/mock';

const Process = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#013139] mb-4">
            {processData.title}
          </h2>
          <p className="text-xl text-gray-600">
            {processData.subtitle}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 relative">
            {/* Connecting line - only visible on desktop */}
            <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-[#013139] via-[#00E5A3] to-[#013139]" 
                 style={{ width: 'calc(100% - 120px)', left: '60px' }} />

            {processData.steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Number circle */}
                <div className="relative mb-6">
                  <div className="w-24 h-24 mx-auto bg-gradient-to-br from-[#013139] to-[#024F5B] rounded-full flex items-center justify-center shadow-lg z-10 relative">
                    <span className="text-3xl font-bold text-[#00E5A3]">
                      {step.number}
                    </span>
                  </div>
                  {/* Glow effect */}
                  <div className="absolute inset-0 w-24 h-24 mx-auto bg-[#00E5A3]/20 rounded-full blur-xl" />
                </div>

                {/* Content */}
                <div className="text-center">
                  <h3 className="text-xl font-bold text-[#013139] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Timeline on mobile */}
        <div className="md:hidden mt-12 max-w-md mx-auto">
          <div className="relative pl-8 border-l-2 border-[#00E5A3]">
            {processData.steps.map((step, index) => (
              <div key={index} className="relative pb-12 last:pb-0">
                <div className="absolute -left-10 w-6 h-6 bg-[#00E5A3] rounded-full border-4 border-white" />
                <div className="bg-gray-50 p-6 rounded-xl">
                  <span className="text-2xl font-bold text-[#00E5A3]">{step.number}</span>
                  <h3 className="text-lg font-bold text-[#013139] mt-2 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
